// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  state: 'BW',
  applicationId: 'ecosure',
  localStorageKey: 'JWT-TOKEN-BWA-DEV',
  interval: { idle: 600, timeout: 60, ping: 15 },
  defaultLanguage: 'en-bw',
  languages: [{ code: 'en-bw', name: 'English Botswana' }],
  countries: [
    { code: 'ZW', name: 'Zimbabwe' },
    { code: 'BI', name: 'Burundi' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'GH', name: 'Ghana' },
    { code: 'BW', name: 'Botswana' }
  ],
  modules: {
    dashboard: true,
    burialSocieties: false,
    individuals: true,
    claims: true,
    reports: false,
    salesForce: false,
    payments: false,
    packagesAndAddOns: false,
    education: false,
    search: false,
    scheduledTasks: false,
    commissions: false
  },
  subModules: {
    individuals: {
      registrationType: 'FULL_LOOKUP',
      auditTrail: true,
      beneficiaries: true,
      bulkPayments: false,
      bulkOperations: false,
      bulkPolicyHolders: false,
      bulkDependants: false,
      changeBeneficiary: false,
      changePackage: true,
      changePaymentChannel: false,
      changeMSISDN: true,
      dependants: true,
      editPolicyHolder: true,
      invoices: true,
      notifications: false,
      payments: true,
      realization: false,
      reconciliations: false,
      refunds: false,
      refreshSubscriberDetails: false,
      removeBeneficiary: true,
      sponsor: false,
      addOns: false,
      viewReports: false,
      policy: { close: true, activate: false, refund: false },
      sockets: { policyNotification: false }
    },
    commissions: {
      myRegistrations: false,
      myCommissions: false,
      agentCommissions: false,
      agentRegistrations: false,
      commissionsReport: false
    }
  },
  validators: {
    personName: {
      enabled: true,
      required: true,
      regex: `^([a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*)?$`
    },
    address: {
      enabled: true,
      required: true,
      regex: `^([a-zA-Z0-9]+([\-\',\. ]*[a-zA-Z0-9]+)*)?$`
    },
    msisdn: {
      enabled: false,
      required: true,
      regex: `^([0-9]{1}[0-9]{9,11})?$`
    },
    idNumber: { enabled: false, required: false, regex: undefined },
    burialSocietyName: {
      enabled: true,
      required: true,
      regex: `^((?![\-\'\.\s 0-9]*$)[a-zA-Z0-9\-\'\. ]{3,})?$`
    }
  },
  url: {
    //live portal is deployed on http://10.247.10.207

    issuer: 'https://karabo.sasai.global', //10.247.10.204:8095
    api: 'https://karabo.sasai.global', //http://10.247.10.199:20000
    base_individuals: '/ecosure-portal-backend/api/v1',
    base_file_storage: 'https://karabo.sasai.global/ecosure-file-storage-service/api/v1/ecosure-file-storage', //http://10.247.10.199:15228/
    base_claims: '/ecosure-claims-manager',  //http://10.247.10.199:15230/
    token_interceptor: 'https://karabo.sasai.global/auth/realms/EcosureBTC/protocol/openid-connect/token',
    reports: 'https://karabo.sasai.global/v1/report', //http://10.247.10.199:15232/v1/report

    //dev portal is deployed on http://10.247.10.46:8095 

    // issuer: 'http://10.247.10.46:8095',
    // api: 'http://10.247.10.48',
    // base_individuals: ':20000/ecosure-portal-backend/api/v1',
    // base_file_storage: 'http://10.247.10.48:15228/ecosure-file-storage-service/api/v1/ecosure-file-storage',
    // base_claims: ':15230/ecosure-claims-manager',
    // token_interceptor:'http://10.247.10.46:8095/auth/realms/EcosureBTC/protocol/openid-connect/token',
    // reports: 'http://10.247.10.48:15232/v1/report', 

    file: undefined,
    socket: undefined,
    base_burial_societies: '/ecosure-secured-api/api/v1',
    base_keycloak: '/auth/realms/EcosureBTC/protocol/openid-connect',
    base_individuals_bulk_payments: '',
    base_workflow: undefined,
    base_education: undefined,
   
  },
  claimTypes: {
    funeral: { id: 1, name: 'Funeral Cover' },
    hospitalCashback: { id: 3, name: 'Hospital Cash Back' },
    personalAccidentCover: { id: 2, name: 'Personal Accident Cover' },
    zfu: { id: 6, name: 'ZFU' }
  },
  currencies: {
    '1': { id: 1, name: 'United States dollar', code: 'USD' },
    '2': { id: 2, name: 'RAND', code: 'ZAR' },
    '3': { id: 3, name: 'Lesotho loti', code: 'LSL', symbol: 'M' },
    '4': { id: 4, name: 'Zimbabwean dollar', code: 'ZWL', symbol: '$' },
    '5': { id: 5, name: 'Burundian franc', code: 'BIF' },
    '6': { id: 6, name: 'Botswana Pula', code: 'BWP' }
  } /*
  primary
  secondary
  success
  danger
  warning
  info
  light
  dark
  */,
  statuses: [
    { name: 'DRAFT', colour: 'info' },
    { name: 'ACTIVE', colour: 'success' },
    { name: 'PENDING_VERIFICATION', colour: 'warning' },
    { name: 'COMPLETED SUCCESSFULY', colour: 'success' },
    { name: 'COMPLETED FAILED', colour: 'danger' },
    { name: 'REJECTED', colour: 'danger' },
    { name: 'VERIFIED', colour: 'success' },
    { name: 'NEW', colour: 'info' },
    { name: 'NCE_APPLY', colour: 'warning' },
    { name: 'POLICY CLOSED', colour: 'dark' },
    { name: 'PENDING_ACTIVATION', colour: 'info' },
    { name: 'PENDING_APPROVAL', colour: 'info' },
    { name: 'POSTED', colour: 'success' },
    { name: 'FAILED', colour: 'danger' },
    { name: 'CLOSED', colour: 'success' },
    { name: 'EXPIRED', colour: 'danger' },
    { name: 'DELETED', colour: 'danger' },
    { name: 'DECEASED', colour: 'danger' },
    { name: 'SUCCESSFUL', colour: 'success' },
    { name: 'OPEN', colour: 'success' }
  ]
}; // Configure Auto Logout, values are in seconds // 10 minutes // 1 minute // 15 seconds // phone number formats // get id numbers first

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
